// VUEX
/*global _ */
import Vue from "vue";
import Vuex from "vuex";

// import { app as feathersClient } from "../feathers";

Vue.use(Vuex);

// Added Modules
import auth from "./modules/auth";
import site from "./modules/site";
import wndw from "./modules/wndw";
import actions from "./modules/actions";

// import { cacheCbGen } from "Js/cacher.js";

const store = new Vuex.Store({
  modules: {
    auth,
    site,
    wndw,
    actions
  },
  plugins: [],
  state: {}
});

export default store;

